import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { getAllCategorys, getFillterCategorys } from '../../redux/actions/category';
import { useStateContext } from '../../context/ContextProvider';
import { FeaturedMealsCard, Loader, MealCategoryCard } from '../utils';
import { motion } from 'framer-motion';
import { getAllFeaturedMeals } from '../../redux/actions/featuredMeals';

function FeaturedMealSections() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { currentLang, currentDir } = useStateContext();
  const IsArabic = currentLang === "ar";
  const { isLoading, Allmeals } = useSelector((state) => state.FeaturedMeals);

  useEffect(() => {
    // عرض جميع الفئات بدون pagination
    dispatch(getAllFeaturedMeals());
  }, [dispatch]);


  return (
    <section className="py-20 md:py-28 bg-white">
        
      <div className="container">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <div className="flex justify-center mb-4">
            <div className="w-16 h-1 bg-color-1 rounded-full"></div>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl  font-kufi font-bold mb-4 bg-gradient-to-r from-color-1 to-color-2 bg-clip-text text-transparent pb-6">
            {t("Featured Meals")}
          </h2>
          <p className="text-gray-500 dark:text-gray-400 max-w-2xl mx-auto body-1">
            {t("discover our delicious and diverse selection of featured meals, crafted to satisfy delight your taste buds.")}
          </p>
          <div className="flex justify-center mt-4">
            <div className="w-20 h-1 bg-color-1/50 rounded-full"></div>
          </div>
        </motion.div>

{isLoading ? (<Loader/>):(
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3  gap-6 md:gap-8">
    {Allmeals?.map((meal, index) => (
      <FeaturedMealsCard meals={meal}  />
    ))}
  </div>
)}
        
      </div>
      <div className="w-full flex items-center justify-center pt-10">
  <motion.button
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.95 }}
    onClick={() => window.location.href = '/AllFeaturedMeals'}
    className="px-8 py-3 border-2 border-color-1 text-color-1 rounded-full hover:bg-color-1 hover:text-white transition-all duration-300 font-kufi font-normal"
  >
    {t("view all Featured Meals")}
  </motion.button>
</div>
    </section>
  );
}

export default FeaturedMealSections;